import React from 'react';
import '../components/components.css';

import Header from '../components/Header';
import AboutContent from '../components/AboutContent';
import Footer from '../components/Footer';

export default function About() {
  return (
    <div className='container mt-2'>
      <Header />
      <AboutContent />
      <hr />
      <Footer />
    </div>
  );
}
